import { render, staticRenderFns } from "./UjianProcessKecermatan.vue?vue&type=template&id=6398a522&scoped=true"
import script from "./UjianProcessKecermatan.vue?vue&type=script&lang=js"
export * from "./UjianProcessKecermatan.vue?vue&type=script&lang=js"
import style0 from "./UjianProcessKecermatan.vue?vue&type=style&index=0&id=6398a522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6398a522",
  null
  
)

export default component.exports